import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MasterHelper } from 'src/app/core/utilities';
import { UserProfile } from 'src/app/core/models/user';
import { ToastViewModel } from 'src/app/core/models/view-model';
import {  MatAutocomplete } from '@angular/material/autocomplete';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { SimilarRegulationFilter } from 'src/app/core/models/regulation/similar-regulation-filter';
import { RegulationService } from 'src/app/core/services/regulation';
import { SimilarRegulationDataModel, SimilarRegulationModel } from 'src/app/core/models/regulation/similar-regulation-model';
import { AdditionalFilter } from 'src/app/core/models/rulebook/additional-filter';
//import _ = require('underscore');
import * as _ from 'underscore';
import { RegulationDetail } from 'src/app/core/models/regulation/regulation-detail';
import { ChangeViewerDialogComponent } from '../change-viewer-dialog/change-viewer-dialog.component';
import { AssessmentDialogComponent } from '../../shared/assessment-dialog/assessment-dialog.component';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { GlobalService } from 'src/app/core/services/global/global.service';




@Component({
  selector: 'app-jurisdiction-dialog',
  templateUrl: './jurisdiction-dialog.component.html',
  styleUrls: ['./jurisdiction-dialog.component.scss']
})
export class JurisdictionDialogComponent implements OnInit {

  toastModel: ToastViewModel;
  isToastShow = false;
  userProfile!: UserProfile;
  filterType!: string;

  selectedJuris: ItemIdModel[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];

  @ViewChild('juriInput')
  juriInput!: ElementRef<HTMLInputElement>;
  @ViewChild('juriAutocomplete')
  juriAutocomplete!: MatAutocomplete;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  searchedJuris!: ItemIdModel[];
  similarResult: SimilarRegulationDataModel;
  linkedUpdates: SimilarRegulationModel[] = [];
  searchedlinkedUpdates: SimilarRegulationModel[] = [];
  totalCount = 0;
  isTableLoaded = false;
  endIndex = 0;
  filters: AdditionalFilter;
  isSelectAll = false;
  isSelectAssessed = false;
  selectedIds: number[] = [];
  userJurisdiction:string;


  constructor(
    private sessionService: SessionService,
    public dialogRef: MatDialogRef<JurisdictionDialogComponent>,
    // @Inject(MAT_DIALOG_DATA) public searchedJuris: ItemIdModel[])
    @Inject(MAT_DIALOG_DATA) public data: any, private regulationService: RegulationService,private dialog: MatDialog,
    private _globalService: GlobalService) {
    this.toastModel = new ToastViewModel();
    this.filters = new AdditionalFilter();
    this.userJurisdiction = '';
    this.similarResult = new SimilarRegulationDataModel();
  }

  async ngOnInit(): Promise<void> {
    //this.userProfile= await this.sessionService.getLoginUserInfo().toPromise();
    this.userProfile = await this._globalService.getLoginUserData();
    let searchedId = this.userProfile.lastUsedJurisdictionId;
    if (this.data.result && this.data.result.length > 0) {
      if (searchedId) {
        this.searchedJuris = this.data.result;
        var filterDivision = this.searchedJuris.filter(s => s.id.toString() == searchedId.toString());
        if (filterDivision && filterDivision.length > 0) {
          this.userJurisdiction = filterDivision[0].name;
          this.selectedJuris.push(filterDivision[0]);
        }
        if (this.data.regulationDetails.id === 0 && this.data.regulationDetails.similarIndex && this.selectedJuris.length > 0) {
          this.fetchSimilarRegulation();
        } else {
          this.isTableLoaded = true;
        }
        //this.fetchSimilarRegulation();
      }
      else {
        this.userJurisdiction = this.searchedJuris[0].name;
        this.selectedJuris.push(this.searchedJuris[0]);
      }
    }
    this.filters.SortKey = 'id';
    this.filters.IsDesc = true;
  }

  closeDialog(): void {
    
    // if (this.selectedJuris.length === 0) {
    //   this.toastModel.Title = 'Warning';
    //   this.toastModel.Type = 'warning';
    //   this.toastModel.Message = 'Please select jurisdiction';
    //   this.isToastShow = true;
    //   setTimeout(() => {
    //     this.isToastShow = false;
    //   }, 5000);
    // } else {
    //   const selectedJuridiction = MasterHelper.getStringArrayFromObjectArray(this.selectedJuris);
    //   this.data.regulationDetails.selectedLinkedIds = this.selectedIds;
    //   this.data.result = selectedJuridiction
    //   this.dialogRef.close(this.data);
    // }
    // let searchedId = localStorage.getItem('selectedDivision');

    let searchedId = this.userJurisdiction
    this.data.regulationDetails.selectedLinkedIds = this.selectedIds;
    this.data.result = [searchedId];
    this.dialogRef.close(this.data);
  }

  fetchSimilarRegulation(): void {
    const similarFilter = new SimilarRegulationFilter();
    similarFilter.similarIndex = this.data.regulationDetails.similarIndex;
    similarFilter.jurisdiction = MasterHelper.getStringArrayFromObjectArray(this.selectedJuris);
    similarFilter.type=this.data.type;
    this.regulationService.getSimilarRegulation(similarFilter).subscribe((result: SimilarRegulationDataModel) => {
      this.similarResult = result;
      this.linkedUpdates = result.similarRegulations;
      this.searchedlinkedUpdates = result.similarRegulations;
      this.totalCount = result.similarRegulations ? result.similarRegulations.length : 0;
      this.isTableLoaded = true;
      this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
    });
  }

  sortItem(key: string): void {
    this.filters.IsDesc = !this.filters.IsDesc;
    this.filters.SortKey = key;
    this.linkedUpdates = this.filters.IsDesc ? _.sortBy(this.linkedUpdates, [key]).reverse()
      : _.sortBy(this.linkedUpdates, [key]);
  }

  selectAllItem(event: any): void {
    this.selectedIds = [];
    if (event.target.checked === true) {
      if (this.linkedUpdates) {
        this.linkedUpdates.forEach(element => {
          this.selectedIds.push(element.id);
        });
      }
      this.isSelectAll = true;
      this.isSelectAssessed = true;
    } else {
      this.isSelectAll = false;
      this.isSelectAssessed = false;
    }
  }

  selectItem(event: any, id: number): void {
    if (event.target.checked === true) {
      this.selectedIds.push(id);
    } else {
      const index = (this.selectedIds as number[]).indexOf(id);
      if (index >= 0) {
        (this.selectedIds as number[]).splice(index, 1);
      }
    }
    this.isSelectAll = this.linkedUpdates.length === this.selectedIds.length ? true : false;
    const findAllId = [];
    if (this.similarResult.impactAssessmentIds) {
      this.similarResult.impactAssessmentIds.forEach(element => {
        const index = (this.selectedIds as number[]).indexOf(element.id);
        if (index >= 0) {
          findAllId.push(element);
        }
      });
    }
    this.isSelectAssessed = findAllId.length === this.similarResult.impactAssessmentIds.length ? true : false;
  }

  selectAllAssessed(event: any): void {
    if (event.target.checked === true) {
      if (this.similarResult.impactAssessmentIds) {
        this.similarResult.impactAssessmentIds
          .forEach(element => {
            this.selectedIds.push(element.id);
          });
      }
      this.isSelectAssessed = true;
    } else {
      if (this.similarResult.impactAssessmentIds) {
        this.similarResult.impactAssessmentIds
          .forEach(element => {
            this.selectedIds.splice(this.selectedIds.indexOf(element.id), 1);
          });
      }
      this.isSelectAssessed = false;
    }
    this.isSelectAll = this.linkedUpdates.length === this.selectedIds.length ? true : false;
  }

  checkSelectedItem(id: number): boolean {
    if (this.selectedIds.length === 0) {
      return false;
    } else {
      const result = this.selectedIds.find(a => +a === +id);
      return result ? true : false;
    }
  }
  openEditPopup(id: string): void {
    const regDetails = new RegulationDetail();
    let isContain=id.includes('|')
    if(isContain){
      let arr=id.split('|');
      if(arr && arr.length>1){
        regDetails.regulationId=Number(arr[1]);
        let filterDivision=this.searchedJuris.filter(s => s.name.toString()==arr[0]);
          if(filterDivision && filterDivision.length>0){
            localStorage.setItem('linkedClosedIdJurisdiction', filterDivision[0].id.toString());
          }
      }
    }
    else{
      regDetails.regulationId =Number(id);
    }
    regDetails.filterType = 'Current Actions';
    localStorage.setItem('IsEditlinkedClosedId', "true");
    const dialogRef = this.dialog.open(ChangeViewerDialogComponent, {
      width: '1000px',
      data: regDetails,
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }
  openAssessmentPopup(id: number): void {
    const dialogRef = this.dialog.open(AssessmentDialogComponent, {
      width: '1800px',
      height: '870px',
      data: id
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }
}
